export default __webpack_public_path__ + "static/media/house-excess.d8d919b9.gif";